export const ATTACH_REFAB_FILES_PATH = `request/refab/attach_files`;
